// components/axiosInterceptor.js
import { myAxios } from "../services/helper";
import { toast } from "react-toastify";

myAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    const config = error.config;

    if (config && config.customErrorHandler) {
      return Promise.reject(error);
    }

    if (error.response) {
      const status = error.response.status;
      switch (status) {
        case 400:
          toast.error("Bad request. Please check the data.");
          break;
        case 401:
          toast.error("Unauthorized! Please login again.");
          break;
        case 403:
          toast.error("Forbidden! You don't have access.");
          break;
        case 404:
          if (error.config.url.includes("/user/forgot")) {
            toast.error("Username or Email does not exist.");
          } else if (!error.config.url.includes("/attorneyDetails/")) {
            toast.error("Resource not found.");
          }
          break;
        case 408:
          toast.error("Request timeout. Try again later.");
          break;
        case 409:
          toast.error("Conflict! Duplicate or conflicting data.");
          break;
        case 429:
          toast.error("Too many requests. Please slow down.");
          break;
        case 500:
          toast.error("Internal server error. Please try again later.");
          break;
        case 502:
          toast.error("Bad gateway. Server not responding properly.");
          break;
        case 503:
          toast.error("Service unavailable. Server might be down.");
          break;
        case 504:
          toast.error("Gateway timeout. Server took too long to respond.");
          break;
        default:
          toast.error(`Unexpected error (Status: ${status})`);
      }
    } else {
      toast.error("Network error or no response from server.");
    }

    return Promise.reject(error);
  }
);
